import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {FaAngleDoubleLeft, FaAngleDoubleRight} from 'react-icons/fa';
import _ from 'lodash';
import { fetchEmployee, fetchUpdateEmployee } from '../../actions/EmployeeActions';
import { fetchUpdatePackageProgress } from '../../actions/EnrollmentActions';
import { ContentCard } from '../Cards';
import EmployeeSchema from './EmployeeSchema';
import EmployeeUISchema from './EmployeeUISchema';
import {
    setNullToUndefined,
    setPersonTobaccoFields,
    validateDates
} from '../../utils/FormHelper';
import { Form } from '../../utils/FormTemplates';
import { stepNumberHelper } from '../../utils/StepNumberHelper';
import { userService } from '../../utils/UserService';
import { validatePhoneNumber, validateSocialSecurity } from '../../validators/rjsf';

import '../../styles/components.scss';

class EmployeeDetail extends Component {
    state = {
        personId: null,
        employee: null,
        schema: null,
        uiSchema: null
    };

    componentDidMount() {
        userService
            .currentPersonId()
            .then(personId => {
                this.setState({
                    personId: personId
                }, () => {
                    if (this.props.packageId) {
                        return this.props.fetchEmployee(personId, this.props.packageId);
                    }
                });
            });
    }

    validate = (formData, errors) => {
        validatePhoneNumber(formData, errors, (o) => o.phonePrimary, true);
        validatePhoneNumber(formData, errors, (o) => o.phoneAlternate, false);
        validateSocialSecurity(formData, errors, (o) => o.usSocialSecurityNumber);
        return errors;
    };

    onUpdateEmployee = e => {
        if (this.props.packageId) {
            if (validateDates([
                'dateOfBirth',
                'dateOfDeath',
                'previousSmokerQuitDate',
                'otherCoverageEffectiveDate'],
                e.formData,
                e.schema
            )) {
                this.props
                    .updateEmployee(this.state.personId, this.props.packageId, e.formData)
                    .then(() => {
                        let currentStepNumber = stepNumberHelper.stepNumberForNamedStep(this.props.activePackage, 'EmployeeInfo');
                        this.props
                            .fetchUpdatePackageProgress(this.props.packageId, currentStepNumber, true)
                            .then(() => {
                                this.props.history.push(`/packages/${this.props.packageId}/dependents`);
                            });
                    });
            }
        }
    };

    onFormChange = e => {
        if (e && e.formData) {
            let employee = _.cloneDeep(e.formData);
            let schema = _.cloneDeep(e.schema);
            let uiSchema = _.cloneDeep(e.uiSchema);

            setPersonTobaccoFields(employee, schema, uiSchema);

            this.setState({ employee: employee });
            this.setState({ schema: schema });
            this.setState({ uiSchema: uiSchema });
        }
    };

    onCancel = e => {
        this.props.history.push(`/packages/${this.props.packageId}/welcome`);
    };

    render() {
        const { item: employee, loading, error } = this.props.activeEmployee;

        const schema = _.cloneDeep(EmployeeSchema);
        schema.title = employee?.name ?? '';

        const uiSchema = _.cloneDeep(EmployeeUISchema);

        setNullToUndefined(employee);

        setPersonTobaccoFields(employee, schema, uiSchema);

        return (
            employee ?
                <span>
                    <ContentCard loading={loading} error={error}>
                        <h2>Employee Information</h2>
                        <Form schema={this.state.schema ? this.state.schema : schema}
                            uiSchema={this.state.uiSchema ? this.state.uiSchema : uiSchema}
                            formData={this.state.employee ? this.state.employee : employee}
                            onSubmit={e => this.onUpdateEmployee(e)}
                            onChange={e => this.onFormChange(e)}
                            validate={this.validate}
                        >
                            
                        <div>
                            <button disabled={!this.props.activePackage} type="button" className="btn btn-default mr-2" onClick={e => this.onCancel(e)}><FaAngleDoubleLeft />Back</button>
                            <button disabled={!this.props.activePackage} type="submit" className="btn btn-primary float-right">Save &amp; Continue<FaAngleDoubleRight /></button>
                        </div>

                        </Form>
                    </ContentCard>
                </span>
                : <span />
        );
    }

}

const mapStateToProps = (state) => {
    return {
        activeEmployee: state.employees.activeEmployee,
        activePackage: state.packages.activePackage.data
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchEmployee: (personId, packageId) => {
            dispatch(fetchEmployee(personId, packageId));
        },
        updateEmployee: (personId, packageId, employee) => {
            return dispatch(fetchUpdateEmployee(personId, packageId, employee));
        },
        fetchUpdatePackageProgress: (packageId, stepNumber, updateSteps) => {
            return dispatch(fetchUpdatePackageProgress(packageId, stepNumber, updateSteps));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EmployeeDetail));